import type { SpendInsightsLastRequestParams } from '../types/ReportSpendSummarySchema';
import type { StateSchema } from 'app/providers/StoreProvider';

export const getReportSpendSummary = (state: StateSchema) =>
    state?.reportSpendSummary?.summary;

export const getReportSpendSummaryLoading = (state: StateSchema) =>
    state?.reportSpendSummary?.summaryLoading;

export const getReportSpendSummaryError = (state: StateSchema) =>
    state?.reportSpendSummary?.summaryError;

export const getReportSpendProducts = (state: StateSchema) =>
    state?.reportSpendSummary?.products;

export const getReportSpendProductsLoading = (state: StateSchema) =>
    state?.reportSpendSummary?.productsLoading;

export const getReportSpendProductsError = (state: StateSchema) =>
    state?.reportSpendSummary?.productsError;

export const getReportSpendByCategory = (state: StateSchema) =>
    state?.reportSpendSummary?.byCategory ?? [];

export const getReportSpendByCategoryLoading = (state: StateSchema) =>
    state?.reportSpendSummary?.byCategoryLoading;

export const getReportSpendByCategoryError = (state: StateSchema) =>
    state?.reportSpendSummary?.byCategoryError;

export const getReportSpendBySupplier = (state: StateSchema) =>
    state?.reportSpendSummary?.bySupplier ?? [];

export const getReportSpendBySupplierLoading = (state: StateSchema) =>
    state?.reportSpendSummary?.bySupplierLoading;

export const getReportSpendBySupplierError = (state: StateSchema) =>
    state?.reportSpendSummary?.bySupplierError;

export const getReportSpendOvertime = (state: StateSchema) =>
    state?.reportSpendSummary?.overtime ?? [];

export const getReportSpendOvertimeLoading = (state: StateSchema) =>
    state?.reportSpendSummary?.overtimeLoading;

export const getReportSpendOvertimeError = (state: StateSchema) =>
    state?.reportSpendSummary?.overtimeError;

export const getReportSpendFilterSuppliers = (state: StateSchema) =>
    state?.reportSpendSummary?.filterSuppliers ?? [];

export const getReportSpendLastRequestParams = (
    state: StateSchema,
): SpendInsightsLastRequestParams | null =>
    state?.reportSpendSummary?.lastRequestParams ?? null;
